import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Box, Container, Snackbar } from '@mui/material';

import MembershipResults from 'src/components/membership/MembershipListResults';
import { CONSTANTS, STRINGS } from 'src/commons';
import Toolbar from 'src/components/membership/Toolbar';
import { commonReducerAction } from 'src/redux/reducers/common';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { membershipPlanReducerAction } from 'src/redux/reducers/membershipPlan';
import { deleteMembershipPlan, getMembershipPlan } from 'src/api/membership';
import ConfirmDialog from 'src/components/ConfirmationBox';

const MambershipPlan = () => {
  const { startLoading, stopLoading } = loaderReducerAction;
  const [membershipPlans, setMembershipPlans] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, gymId } = useSelector((state) => state.common);
  const { membershipPlanList } = useSelector((state) => state.membershipPlan);
  const { updateMembershipPlans } = membershipPlanReducerAction;
  const { logoutUser } = commonReducerAction;
  const [searchLoader, setSearchLoader] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteMembershipPlanData, setDeleteMemberShipPlanData] = useState({});
  const [deleting, setDeleting] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  const getData = () => {
    dispatch(startLoading());
    getMembershipPlan(user, gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN) logoutUser();
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          if (res?.data?.data) {
            setMembershipPlans(res.data?.data);
            dispatch(updateMembershipPlans(res.data?.data));
          }
        }
        dispatch(stopLoading());
      })
      .catch((err) => {
        dispatch(stopLoading());
        console.log(err);
      });
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onEdit = (item) => {
    navigate(
      CONSTANTS.ROUTES.PRIVATE_ROUTES.EDIT_MEMBERSHIP_PLAN + '/' + item._id
    );
  };
  const onDelete = (item) => {
    dispatch(startLoading());
    setDeleting(true);
    deleteMembershipPlan(user, item._id)
      .then((res) => {
        if (res?.status === 200) {
          setSnackbarState({
            open: true,
            message: 'Membership plan deleted successfully',
            severity: 'success'
          });
        } else if (res?.status !== 200) {
          setSnackbarState({
            open: true,
            message: res?.message || 'Something went wrong',
            severity: 'error'
          });
        }
        setDeleting(false);
        setDeleteModal(false);
        getData();
      })
      .catch((err) => {
        setSnackbarState({
          open: true,
          message: err?.message || 'Something went wrong',
          severity: 'error'
        });
        dispatch(stopLoading());
        setDeleting(false);
        setDeleteModal(false);
      });
  };

  const filterItem = (text) => {
    setSearchLoader(true);
    setMembershipPlans(
      membershipPlanList?.filter((member) =>
        member.name.toLowerCase().includes(text?.trim()?.toLowerCase())
      )
    );
    setSearchLoader(false);
  };

  return (
    <>
      <Helmet>
        <title>MembershipPlan | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            searchLoader={searchLoader}
            filterItem={filterItem}
            text={STRINGS.ADD_MEMBERSHIP_PLAN}
            route={CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_MEMBERSHIP_PLAN}
          />
          <Box sx={{ pt: 3 }}>
            <MembershipResults
              memberShipPlan={membershipPlans}
              onEdit={onEdit}
              onDelete={(item) => {
                setDeleteMemberShipPlanData(item);
                setDeleteModal(true);
              }}
            />
          </Box>
        </Container>
      </Box>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <div>
          <Alert onClose={handleClose} severity={snackbarState.severity}>
            {snackbarState.message}
          </Alert>
        </div>
      </Snackbar>
      <ConfirmDialog
        heading={'Delete Membership Plan'}
        message={'Do you want to delete the membership plan?'}
        open={deleteModal}
        handleClose={() => {
          setDeleteModal(false);
        }}
        handleConfirm={() => {
          onDelete(deleteMembershipPlanData);
        }}
        loading={deleting}
        key={'detete modal'}
      />
    </>
  );
};

export default MambershipPlan;
